import { addQuote } from '../utils';
const axios = require('axios');

let perPage = 9;
let offset = 2;

function handleIntersect(entries, observer) {
  entries.forEach((entry) => {

    if(entry.intersectionRatio === 1) {
      axios.get(`/wp-json/wp/v2/quote/?per_page=${perPage}&page=${offset}`)
      .then(function (response) {
        response.data.map(item => addQuote(item));

        const quoteList = document.querySelector('.row-quotes .et_pb_code_inner > div:last-child');

        if(quoteList) {
          observerQuote(quoteList);
        }
      });

      offset++;
      observer.disconnect();
    }
  });
}

export function observerQuote(element) {
  let options = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0
  }
  
  let observer = new IntersectionObserver(handleIntersect, options);
  observer.observe(element);
}


// WEBPACK FOOTER //
// ./src/js/utils/observerQuote.js